import { brandColor, getClassTextForColor } from '../../util/ColorUtil';
import Image from 'next/image';
import React from 'react';
import { modifyLinks } from '../../util/DataUtil';
import {useRouter} from "next/router";

const CardStepper = ({ data }) => {
  let items = data?.field_card_stepper_items?.image_text_description_paragraph;
  const { locale } = useRouter();

  const renderItems = () => {
    return items.map((item, index) => {
      return (
        <div className={'item'} key={`card-stepper-key-${item?.field_title?.[0]?.value || index}`}>
          <div className={'left'}>
            <div className={'left-helper'}>
              <h2>{item?.field_title[0]?.value}</h2>
              <span
                className={'description'}
                dangerouslySetInnerHTML={{
                  __html: modifyLinks(
                    item?.field_subtitle_color_paragraph[0]?.value,
                    locale
                  ),
                }}
              />
            </div>
            <span className={'index'}>{'0' + (index + 1)}</span>
          </div>
          <div className={'right'}>
            <Image
              priority
              layout="fill"
              alt="featured"
              src={
                item?.field_cloudinary_image_paragraph[0]
                  ? item?.field_cloudinary_image_paragraph[0]
                  : '/images/placeholderBanner.png'
              }
            />
          </div>
        </div>
      );
    });
  };

  return (
    <div
      className={
        'card-stepper ' +
        getClassTextForColor(data?.field_background_color[0]?.value)
      }
      style={{
        backgroundColor: brandColor(data?.field_background_color[0]?.value),
      }}
    >
      <div className={'inner-container'}>{renderItems()}</div>
    </div>
  );
};

export default CardStepper;
